import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import MagnifyingGlass from '../../assets/svgr/MagnifyingGlass';
import './styles.scss';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box className='notfound-container'>
      <Container>
        <Grid container alignItems='center'>
          <Grid
            item
            xs={12}
            className='notfound-footer'
          >
            <MagnifyingGlass />
            <Typography className='notfound-title'>Page Not Found</Typography>
            <Typography className='notfound-text'>The page you’re looking for doesn’t exist or is unavailable.</Typography>
            <Button
              onClick={() => navigate('/')}
              size='large'
              variant='contained'
              color='primary'
              className='homepage-button'
            >
              Go to homepage
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default NotFound;
